<template>
  <div class="user-group-selector">
    <template v-if="ready">
      <create-group-dialog v-model="showDialog" @create="onCreateGroup"></create-group-dialog>
      <zg-selector
        :store="groupList"
        :width="200"
        :filterGroup="false"
        ref="selector"
        filterOption
        key-field="id"
        label-field="name"
        v-model="chosen"
        children-field="children"
        placeholder="请选择用户群"
        @change="onChange"
      >
        <template slot="header" slot-scope="scope">
          <span
            @click="showGroupDialog"
            style="display: inline-block;width: 100%"
          >
            <span class="icon-add"></span>
            {{ scope.data.name }}
          </span>
        </template>
        <template slot-scope="scope">
          <span :title="scope.data.name">{{ scope.data.name }}</span>
        </template>
      </zg-selector>
    </template>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {actions} from '../../store/constants'
import CreateGroupDialog from './groupDialog'
export default {
  name: 'userGroupSelector',
  components: {
    CreateGroupDialog
  },
  props: {
    value: null
  },
  data () {
    return {
      chosen: this.value,
      showDialog: false
    }
  },
  computed: {
    ...mapState({
      groupList (state) {
        return [
          {
            id: -1,
            name: '新建用户群',
            children: state.bizUserGroup.list
          }
        ]
      },
      ready (state) {
        const ready = state.bizUserGroup.ready.list
        return ready
      }
    })
  },
  beforeCreate () {
    this.$store.dispatch(actions.userGroup.query)
  },
  methods: {
    showGroupDialog () {
      this.$refs.selector.showOptions = false
      this.showDialog = true
    },
    onChange () {
      this.$emit('input', this.chosen)
    },
    onCreateGroup (group) {
      this.chosen = group
      this.onChange()
    }
  }
}
</script>

<style lang="sass">
@import '../../assets/constants'
.user-group-selector
  display: inline-block
  .c-header
      background: $color-bg-normal
      color: #b2b2b2
      font-weight: bold
      cursor: pointer
      &:hover
        color: $color-brand
</style>
